import { useState } from "react";

export function DocCard({ title, items, labels, idx }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="card doc-card" data-testid={`doc-card-${idx + 1}`}>
      <h3 className="h3">{title}</h3>
      <ul className="list">
        {(open ? items : items.slice(0, 2)).map((li, i) => <li key={i}>{li}</li>)}
      </ul>
      <button
        type="button"
        className="doc-toggle"
        onClick={() => setOpen(!open)}
        data-testid={`doc-toggle-${idx + 1}`}
      >
        {open ? labels.toggleHide : labels.toggleShow}
      </button>
    </div>
  );
}
